// import CryptoJS from 'crypto-js';
// import compresStorage from './compresStorage';

// const SECRET_KEY =
//   'p@m0F0r$$445**445p@m0F0r$$445**445p@m0F0r$$445**445p@m0F0r$$445**445p@m0F0r$$445**445';

// const encryptData = (data) => {
//   return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
// };

// const decryptData = (encryptedData) => {
//   const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
//   return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
// };

// const secureStorage = {
//   setItem: (key, value) => {
//     const encryptedValue = encryptData(value);
//     compresStorage.setItem(key, encryptedValue);
//   },
//   getItem: (key) => {
//     const encryptedValue = compresStorage.getItem(key);
//     if (encryptedValue) {
//       try {
//         return decryptData(encryptedValue);
//       } catch (e) {
//         console.error('Error decrypting data', e);
//         return null;
//       }
//     }
//     return null;
//   },
//   removeItem: (key) => {
//     compresStorage.removeItem(key);
//   },
//   clear: () => {
//     compresStorage.clear();
//   },
// };

// export default secureStorage;



// secure non haché qui fonctionne comme localStorage

const secureStorage = {
  // setItem: (key, value) => {
  //   const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
  //   localStorage.setItem(key, stringValue);
  // },
  // getItem: (key) => {
  //   const storedValue = localStorage.getItem(key);
  //   if (storedValue) {
  //     try {
  //       return JSON.parse(storedValue);
  //     } catch (e) {
  //       console.error('Error parsing JSON from localStorage', e);
  //       return storedValue; // Return the raw value if parsing fails
  //     }
  //   }
  //   return null;
  // },
  // removeItem: (key) => {
  //   localStorage.removeItem(key);
  // },
  // clear: () => {
  //   localStorage.clear();
  // },

  setItem: (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
  },
  // getItem: (key) => {
  //   const value = localStorage.getItem(key);
  //   return value ? JSON.parse(value) : null;
  // },
  getItem: (key) => {
    const value = localStorage.getItem(key);
    try {
      return value ? JSON.parse(value) : null;
    } catch (error) {
      console.error(`Erreur lors du parsing de la clé "${key}" :`, error);
      return null;
    }
  },
  
  removeItem: (key) => {
    localStorage.removeItem(key);
  },
  clear: () => {
    localStorage.clear();
  },
};

export default secureStorage;